import { monitorValue } from "../../util/monitorUtils";

const buildPantographMatrixData = (monitor) => {
    const matrix = {};

    for (let car = 1; car <= 8; car++) {

        const possuiPantografo =
            car === 2 || car === 7;

        // PANTÓGRAFO 1

        const levantado =
            possuiPantografo &&
            monitorValue(
                monitor,
                `panto1LevantadoCarro${car}`,
                0
            ) !== 0;

        const abaixado =
            possuiPantografo &&
            monitorValue(
                monitor,
                `panto1AbaixadoCarro${car}`,
                0
            ) !== 0;

        const isolado =
            possuiPantografo &&
            monitorValue(
                monitor,
                `panto1IsoladoCarro${car}`,
                0
            ) !== 0;

        const falha =
            possuiPantografo &&
            monitorValue(
                monitor,
                `panto1FalhaCarro${car}`,
                0
            ) !== 0;

        // PANTÓGRAFO 2

        const levantado2 =
            possuiPantografo &&
            monitorValue(
                monitor,
                `panto2LevantadoCarro${car}`,
                0
            ) !== 0;

        const abaixado2 =
            possuiPantografo &&
            monitorValue(
                monitor,
                `panto2AbaixadoCarro${car}`,
                0
            ) !== 0;

        const isolado2 =
            possuiPantografo &&
            monitorValue(
                monitor,
                `panto2IsoladoCarro${car}`,
                0
            ) !== 0;

        const falha2 =
            possuiPantografo &&
            monitorValue(
                monitor,
                `panto2FalhaCarro${car}`,
                0
            ) !== 0;

        matrix[car] = {
            possuiPantografo,
            inverterPantografos: car === 7,

            levantado,

            // PANTO 1
            levantado,
            levantadoCategory:
                monitor?.[`panto1LevantadoCarro${car}`]?.category,

            abaixado,
            abaixadoCategory:
                monitor?.[`panto1AbaixadoCarro${car}`]?.category,

            isolado,
            isoladoCategory:
                monitor?.[`panto1IsoladoCarro${car}`]?.category,

            falha,
            falhaCategory:
                monitor?.[`panto1FalhaCarro${car}`]?.category,

            // PANTO 2
            levantado2,
            levantado2Category:
                monitor?.[`panto2LevantadoCarro${car}`]?.category,

            abaixado2,
            abaixado2Category:
                monitor?.[`panto2AbaixadoCarro${car}`]?.category,

            isolado2,
            isolado2Category:
                monitor?.[`panto2IsoladoCarro${car}`]?.category,

            falha2,
            falha2Category:
                monitor?.[`panto2FalhaCarro${car}`]?.category
        };
    }
    return matrix;
};

export default buildPantographMatrixData;